import { AlignedRecordings } from '../types/clip-types';
import { ContentMetadataState } from '../types/content-metadata-store-types';
import { SpeakerWithDetails } from '../types/speaker-types';
import { Word } from '../types/transcript-types';
import { VideoFeed } from '../types/video-feed-types';

const EMPTY_SPEAKER_DETAILS: Record<string, SpeakerWithDetails> = {};
const EMPTY_ALIGNED_RECORDINGS: AlignedRecordings[] = [];
const EMPTY_VIDEO_FEEDS: VideoFeed[] = [];
const EMPTY_TRANSCRIPT: Word[] = [];

export const selectContentMetadata = (contentId: string) => (state: ContentMetadataState) => state.data[contentId];

export const selectSpeakerDetails = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.metadata?.speakerDetails ?? EMPTY_SPEAKER_DETAILS;

export const selectAlignedRecordings = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.metadata?.alignedRecordings ?? EMPTY_ALIGNED_RECORDINGS;

export const selectVideoFeeds = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.videoFeeds ?? EMPTY_VIDEO_FEEDS;

export const selectTranscript = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.metadata?.transcript ?? EMPTY_TRANSCRIPT;

export const selectSpeakerAnalysis = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.metadata?.speakerAnalysis;

export const selectSpeakerAnalysisLoading = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.loading?.speakerAnalysisLoading ?? false;

export const selectTranscriptLoading = (contentId: string) => (state: ContentMetadataState) =>
  state.data[contentId]?.loading?.transcriptLoading ?? false;
